/**
 * @owner @Appboy/messaging-experience
 */
import { purchaseRemoteLookupValidators } from "../.generated/purchaseRemoteLookup";
import type { PurchaseRemoteLookupProvider } from "../.generated/purchaseRemoteLookup";

export const purchaseProvider: PurchaseRemoteLookupProvider = {
  mapItemToId: (item) => item.indexed_name,
  mapIdToString: (id) => id,
  mapItemToSearchString: (item) => item.name,
  validators: purchaseRemoteLookupValidators,
};
